import gql from 'graphql-tag';

export default gql`
  mutation($publicationUrl: URI!, $suggestionsListId: ID!) {
    addStaffPicksSuggestion(
      input: {
        publicationUrl: $publicationUrl
        suggestionsListId: $suggestionsListId
        libraryComment: ""
      }
    ) {
      code
    }
  }
`;
